import httpClient from "./httpClient";

const prefix = "/branch-schedule";

export async function getScheduleByPartnerAndDate(partnerId: number, date: string) {
  return (await httpClient.get(`${prefix}/partner/${partnerId}/date/${date}`)).data;
}

export async function getScheduleByPartner(partnerId: number, query: string = "") {
    return (await httpClient.get(`${prefix}/schedules/branch/partner/${partnerId}?${query}`)).data;
}

/** Horarios BranchSchedule reales del colaborador en un rango (sin depender de FKs de checada). */
export async function getScheduleByPartnerDateRange(
  partnerId: number,
  startDate: string,
  endDate: string,
  limit = 100
) {
  const query = new URLSearchParams({
    startDate,
    endDate,
    limit: String(limit),
    offset: "0",
  });
  return (
    await httpClient.get(
      `${prefix}/schedules/branch/partner/${partnerId}/date-range?${query.toString()}`
    )
  ).data;
}

export async function removeSchedulesByPartnerAndDate(partnerId: number, date: string) {
  return (await httpClient.delete(`${prefix}/schedules/partner/${partnerId}/date/${date}`)).data;
} 

export async function getCheckClarificationsByBranch(
  branchId: number,
  params?: {
    search?: string;
    sortBy?: string;
    order?: 'ASC' | 'DESC';
    page?: number;
    limit?: number;
  },
) {
  const queryParams = new URLSearchParams();
  if (params?.search) queryParams.append('search', params.search);
  if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
  if (params?.order) queryParams.append('order', params.order);
  if (params?.page) queryParams.append('page', params.page.toString());
  if (params?.limit) queryParams.append('limit', params.limit.toString());

  const queryString = queryParams.toString();
  const url = `${prefix}/check-clarification/branch/${branchId}${queryString ? `?${queryString}` : ''}`;
  return (await httpClient.get(url)).data;
}

export async function updateCheckClarification(id: number, data: { status?: string; adminResponse?: string }) {
  return (await httpClient.patch(`${prefix}/check-clarification/${id}`, data)).data;
}

export async function getCheckClarificationById(id: number) {
  return (await httpClient.get(`${prefix}/check-clarification/${id}`)).data;
} 